import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Route, Routes } from 'react-router-dom';
import { loginRequest } from './auth/msal';
import { AppShell } from './components/AppShell';
import { FormEditorPage } from './components/FormEditorPage';
import { FormList } from './components/FormList';
import { SubmissionsPage } from './components/SubmissionsPage';

export function App() {
  const { instance } = useMsal();

  return (
    <>
      <UnauthenticatedTemplate>
        <div className="page center">
          <h1>Forms Builder</h1>
          <p>Sign in with your organisation account to manage forms.</p>
          <button onClick={() => void instance.loginRedirect(loginRequest)}>Sign in</button>
        </div>
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <AppShell>
          <Routes>
            <Route path="/" element={<FormList />} />
            <Route path="/forms/:id" element={<FormEditorPage />} />
            <Route path="/forms/:id/submissions" element={<SubmissionsPage />} />
          </Routes>
        </AppShell>
      </AuthenticatedTemplate>
    </>
  );
}
